import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiUrl } from "../../../constants";

export const deleteScheduledDelivery = createAsyncThunk(
  "scheduledDelivery/deleteScheduledDelivery",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.user.token;

    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ds_id: data.ds_id }),
    };

    try {
      const response = await fetch(
        `${apiUrl}/delete_scheduled_package_query`,
        requestOptions
      );

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const errorText = await response.text();
          const errorObj = JSON.parse(errorText);
          errorMessage = errorObj.error || errorMessage;
        } catch (e) {
          errorMessage = errorText || errorMessage;
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Failed scheduled delivery:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const deleteScheduledDeliverySlice = createSlice({
  name: "scheduledDelivery",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
    msg: "",
  },
  reducers: {
    resetDeleteScheduledDeliveryState(state) {
      state.status = "idle";
      state.error = null;
      state.msg = "";
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(deleteScheduledDelivery.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteScheduledDelivery.fulfilled, (state, action) => {
        state.msg = action.payload.msg;
        state.status = "success";
        state.error = null;
      })
      .addCase(deleteScheduledDelivery.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetDeleteScheduledDeliveryState } =
  deleteScheduledDeliverySlice.actions;
export default deleteScheduledDeliverySlice.reducer;
